export default __webpack_public_path__ + "static/media/designed_by_number.f0cd2060.svg";